module.exports = __webpack_public_path__ + "img/5be982f338701572f4436382c8e41b3d.png";